import { useState } from "react";
import { UseFormClearErrors, UseFormSetError, UseFormSetValue } from "react-hook-form";
import {
    DEFAULT_CARD_IMAGE,
    formatCardNumber,
    formatCvc,
    getCardTypeByValue,
} from "../../utils/cardFormatter";
import Input from "./Input";
type InputProps = {
    title?: string;
    checkboxTitle?: string;
    checkboxNotClickable?: boolean;
    type?:
    | "text"
    | "radio"
    | "checkbox"
    | "textarea"
    | "number"
    | "email"
    | "password"
    | "date"
    | "time"
    | "address";
    placeholder?: string;
    name?: string;
    onChangeFunction?: (arg0: string) => void;
    options?: { name: string }[];
    className?: string;
    inputClassName?: string;
    checkCard?: string;
    cardValue?: string;
    titleClassname?: string;
    editing?: boolean;
    textBoxClass?: string;
    value?: string | number;
    isChecked?: boolean;
    isDisabled?: boolean;
    children?: JSX.Element | false | undefined;
    setValue?: UseFormSetValue<any>;
    setError?: UseFormSetError<any>;
    clearErrors?: UseFormClearErrors<any>;
    style?: any;
    hidden: boolean;
};
function CVCInput({
    title,
    checkboxTitle,
    checkboxNotClickable,
    type = "text",
    placeholder,
    name = "",
    onChangeFunction,
    options,
    className,
    inputClassName,
    titleClassname,
    editing,
    textBoxClass,
    value = "",
    isChecked = false,
    isDisabled,
    children,
    style,
    checkCard,
    cardValue,
    setError,
    clearErrors,
    setValue,
    hidden,
}: InputProps) {
    const handleCVCChange = (val: string) => {
        val = formatCvc(val);
        if (cardValue && getCardTypeByValue(cardValue)?.cvcLength) {
            setValue?.(name, val.slice(0, getCardTypeByValue(cardValue)?.cvcLength), {
                shouldValidate: true, shouldDirty: true
            });
        } else {
            setValue?.(name, val.slice(0, 3), { shouldValidate: true, shouldDirty: true });
        }
        if (cardValue && val.length < getCardTypeByValue(cardValue)?.cvcLength) {
            setError?.(name, {
                type: "invalidCvc",
                message: "Invalid cvc",
            });
        } else {
            clearErrors?.(name);
        }
    };

    return (
        <Input
            editing={editing}
            title="Code"
            className={className}
            inputClassName={!editing ? 'bg-color15 text-color1' : ''}
            value={hidden && value ? "***" : (value || "")}
            name={name}
            type="text"
            onChangeFunction={(val) => {
                handleCVCChange(val);
            }}
        >
            {children && children}
        </Input>
    );
}

export default CVCInput;
